export default __webpack_public_path__ + "static/media/2-card.8d0044e2.png";